import React from "react";
import CrudPage from "@/components/CrudPage";
import { PERSONA_FIELDS } from "@/lib/anagrafiche";

const FILTERS = [{ name: "competenze", label: "Competenza", optionKey: "competenze" }];

export default function Persone() {
  return (
    <CrudPage
      title="Persone / Partecipanti"
      subtitle="Allievi e tirocinanti collegati ad aziende e corsi"
      endpoint="persone"
      testid="persone-page"
      detailRoute="persone"
      mobileCards
      cfAutofill
      filters={FILTERS}
      columns={[
        { key: "nome", label: "Nominativo", render: (r) => <span className="font-medium text-slate-900 hover:text-[#E11D48]">{r.cognome} {r.nome}</span> },
        { key: "cf", label: "Codice Fiscale", render: (r) => <span className="font-mono text-xs">{r.cf}</span> },
        { key: "email", label: "Email" },
        { key: "cellulare", label: "Cellulare" },
        { key: "competenze", label: "Competenze", render: (r) => (r.competenze || []).slice(0, 2).join(", ") || "—" },
      ]}
      fields={PERSONA_FIELDS}
    />
  );
}
